<div class="toolbar" role="banner" style="position: fixed;">
  <div style="padding: 0px; height: 42px; width: 42px; border: 1px solid #000; margin-left: 5%; margin-right: 5%;">
  </div>
  <span style="color: #fff">VERXID FINGER CAPTURE</span>
  <div class="spacer"></div>
</div>

<ng-template>
  <div class="content" role="main">
    <div class="row">

      <div class="col-12"
        style="display: flex; position: absolute; bottom: 40px; justify-content: center; align-items: center; position: fixed;">
        <div class="row" style=" align-content: center;">
          <button class="btn btn-block" style="background-color: #ffcb00; color: #fff !important; padding: 10px 35px;"
            (click)="refreshCapture()">Refresh</button>
        </div>
      </div>

    </div>

  </div>
</ng-template>